<div class="iflx-widget-body AT_widget_terminal" id="new-terminal-widget">
  <terminal-widget
    is-edit="isEdit"
    merge-settings="mergeSettings"
    options="options"
    update-option="updateOption"
  />
</div>
